import React from "react";
import { IntlProvider as BaseIntlProvider } from "react-intl";
import translations from "../translations/index";

export const IntlProvider = ({ locale = "en", children }) => (
  <BaseIntlProvider locale={locale} messages={translations[locale]}>
    {children}
  </BaseIntlProvider>
);
